import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "items-in-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Добавлено к сравнению", -1)

import { computed, ref, Ref } from 'vue';
import { ResultCardType } from '@/types';
import { useCompareStore } from '@/store/modules/compare';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareIcon',
  props: {
    card: {},
    withBorder: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const showInfoModalKey: Ref<number> = ref(1);
const showInfoModal: Ref<boolean> = ref(false);

const compareId = computed(() => {
  return useCompareStore().compareData?.id;
});
const changeIsCompare = async () => {
  if (
    useCompareStore().getCompareCount() === 1 &&
    useCompareStore().getIsCompare(props.card.id) &&
    compareId.value
  ) {
    await useCompareStore()
      .deleteCompare(compareId.value)
      .then(() => {
        useCompareStore().changeCurrentCompare(undefined, []);
        useCompareStore().changeCompareList([]);
      });
  } else {
    const res = await useCompareStore().changeIsCompare(props.card);

    if (res === 'showInfo') {
      showInfoModalKey.value++;
      showInfoModal.value = true;
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.withBorder)
      ? (_openBlock(), _createBlock(_component_base_button, {
          key: 0,
          icon: "",
          "style-type": "border",
          withoutActive: "",
          onClick: changeIsCompare
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_base_icon, {
              color: _unref(useCompareStore)().getIsCompare(_ctx.card.id) ? '#009D3E' : '#969696',
              name: 
          _unref(useCompareStore)().getIsCompare(_ctx.card.id) ? 'playlist_add_check' : 'playlist_add'
        ,
              "font-size": "20",
              width: "22"
            }, null, 8, ["color", "name"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_base_icon, {
          key: 1,
          color: _unref(useCompareStore)().getIsCompare(_ctx.card.id) ? '#009D3E' : '#969696',
          name: 
      _unref(useCompareStore)().getIsCompare(_ctx.card.id) ? 'playlist_add_check' : 'playlist_add'
    ,
          class: "ml--5",
          clickable: "",
          "font-size": "24",
          onClick: _withModifiers(changeIsCompare, ["prevent"])
        }, null, 8, ["color", "name"])),
    (_openBlock(), _createBlock(_component_base_info_modal, {
      key: showInfoModalKey.value,
      "show-info-modal": showInfoModal.value,
      position: "top-right",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (showInfoModal.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_router_link, {
            to: { name: 'compare' },
            class: "underline white-color"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Перейти к сравнению ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show-info-modal"]))
  ], 64))
}
}

})